// ANCHOR React
import { useCallback, MouseEvent } from 'react';

// ANCHOR Base
import { Button, KIND, SIZE } from 'baseui/button';

// ANCHOR Model
import { ConfirmationModalVisibility } from '@lyon/scoped-models/confirmation-modal/ConfirmationModalVisibility';
import { ConfirmationModalLogic } from '@lyon/scoped-models/confirmation-modal/ConfirmationModalLogic';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Constant
import { CONFIRM, YES } from './constants';

// ANCHOR Styles
import { BUTTON } from './styles';

export const LyonConfirmationModalConfirmButton = constant(() => {
  const hide = ConfirmationModalVisibility.useSelector((state) => state.hide);

  const [
    allow, callback, asyncCallback, loading, isStrict, confirmLabel,
  ] = ConfirmationModalLogic.useSelectors(({ state, check }) => [
    check.allow,
    state.callback,
    state.asyncCallback,
    state.loading,
    state.isStrict,
    state.confirmLabel,
  ]);

  const onClick = useCallback(async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (callback) {
      callback();
    }

    if (asyncCallback) {
      await asyncCallback();
    }

    hide();
  }, [asyncCallback, callback, hide]);

  const defaultLabel = isStrict ? CONFIRM : YES;

  return (
    <Button
      overrides={BUTTON}
      onClick={onClick}
      kind={KIND.primary}
      size={SIZE.default}
      disabled={!allow || (!callback && !asyncCallback)}
      isLoading={loading}
    >
      {confirmLabel || defaultLabel}
    </Button>
  );
});
